import React, { useContext } from 'react';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from '../Common/ThemeProvider';

const DataTableList = ({ columns, data, expandDetails }) => {

    const { CurrentTheme } = useContext(ThemeContext);
    const theme = CurrentTheme === "dark" ? "#25252B" : (CurrentTheme === "blue" ? "#24bbc0" : (CurrentTheme === "loggray" ? "#30655E" : "#005582"));

    const customStyles = {
        headCells: {
            style: {
                fontSize: '14px',
                fontWeight: '600',
                backgroundColor: theme,
                color: "white"
            },
        },
        cells: {
            style: {
                fontSize: '13px',
            },
        },
    };

    return (
        <div style={{ width: "100%", textAlign: "center", border: "1px solid #ccc", borderRadius: "10px" }}>
            <DataTable
                columns={columns}
                data={data}
                responsive
                direction="auto"
                striped
                fixedHeader
                fixedHeaderScrollHeight="65vh"
                highlightOnHover
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                sortIcon={<FontAwesomeIcon icon={faArrowDown} />}
                dense
                pagination
                persistTableHead
                paginationPerPage={10}
                customStyles={customStyles}
                expandableRows={(expandDetails !== undefined && expandDetails !== null) ? true : false}
                expandableRowsComponent={expandDetails}
            />
        </div>
    );
};

export default DataTableList;